import { useState } from 'react';
import type { GridSortModel } from '@mui/x-data-grid';

type UseGridSortStateResult = {
  sortModel: GridSortModel;
  setSortModel: (model: GridSortModel) => void;
  handleSortModelChange: (model: GridSortModel) => void;
};

export const useGridSortState = (initialSortModel: GridSortModel): UseGridSortStateResult => {
  const [sortModel, setSortModel] = useState<GridSortModel>(initialSortModel);

  const normaliseSortModel = (model: GridSortModel): GridSortModel => {
    if (model.length <= 1) return model;
    return [model[0]];
  };

  const handleSortModelChange = (model: GridSortModel): void => {
    setSortModel(normaliseSortModel(model));
  };

  return { sortModel, setSortModel, handleSortModelChange };
};
